import axios from "axios";
import { aliasPlatform } from "../../../utils/helper";

export async function getDomainInfo(
  platform: string,
  domain: string,
  retailerId: string
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v1/${shortPl}/merchant/domain/info`;
  const res = await axios.get(url, {
    params: { domain, retailer_id: retailerId },
  });
  return res.data;
}

export async function createDomain(
  platform: string,
  domain: string,
  retailerId: string
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v1/${shortPl}/merchant/domain/add`;
  const res = await axios.post(url, {
    domain,
    retailer_id: retailerId,
  });
  return res.data;
}

export async function updateDomain(
  platform: string,
  domain: string,
  retailerId: string,
  oldDomain: string
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v1/${shortPl}/merchant/domain/change`;
  const res = await axios.post(url, {
    domain,
    retailer_id: retailerId,
    old_domain: oldDomain,
  });
  return res.data;
}

export async function checkDomainExist(platform: string, domain?: string) {
  const body = {
    platform: aliasPlatform(platform),
    domain,
  };
  const res = await axios.post("api/v1/domain/exists", body);
  return res.data.data;
}

export async function checkStatusListDomainFreeByName(
  storeName: string,
) {
  const url = `api/v2/merchants/domain/available`;
  const res = await axios.get(url, {
    params: { subDomain: storeName },
  });
  return res.data;
}

export async function connectDomain(
  path: string,
  type: "free" | "custom",
) {
  const url = `api/v2/merchants/domain/connect`;
  const res = await axios.post(url, {
    newDomain: path,
    type,
  });
  return res.data;
}

export async function getCurrentDomain() {
  const url = `api/v2/merchants/domain`;
  const res = await axios.get(url);
  // return {
  //   domainDefault: "saoblog.dev-kiotvietweb.fun",
  //   currentDomain: "ducbeo.com.vn",
  //   // yourDomain: "ducbeo.com.vn",
  //   type: "custom",
  //   status: "success",
  //   code: 0
  // }
  return res.data;
}

export async function disconnectCurrentDomain() {
  const url = `api/v2/merchants/domain/disconnect`;
  const res = await axios.post(url);
  return res.data;
}
export async function getCustomDomainInfor(domain: string) {
  const url = `api/v2/merchants/domain/information`;
  const res = await axios.get(url, {
    params: {
      domain
    }
  });
  return res.data;
}
